'use client';

import { useMemo } from 'react';
import type { CartItem } from '@/features/totems/domain/model/cart-item';
import { formatMenuDiscountLabel, getAvailableCartDiscounts } from '@/features/totems/domain/service/menu-discount';
import { useTotemCatalog } from '@/features/totems/presentation/providers/web-totem/totem-provider';
import { cn } from '@/shared/utils/utils';

type Props = {
  items: CartItem[];
  /** Oculta el hint cuando el carrito ya tiene un cupón aplicado. */
  hidden?: boolean;
  className?: string;
};

/**
 * Hint informativo del carrito: cupones vigentes para los productos agregados.
 * El descuento se cobra igual que siempre, tipeando el código en el panel.
 */
export function AvailableDiscountsHint({ items, hidden, className }: Props) {
  const { discountsByProduct } = useTotemCatalog();
  const available = useMemo(() => getAvailableCartDiscounts(items, discountsByProduct), [items, discountsByProduct]);

  if (hidden || available.length === 0) return null;

  return (
    <p className={cn('mt-2 px-2 text-xs font-medium text-orange-500 dark:text-orange-400', className)}>
      Descuento disponible:{' '}
      {available.map(discount => `${discount.code} (${formatMenuDiscountLabel(discount)})`).join(' · ')}. Aplicalo con
      el código en el carrito.
    </p>
  );
}
